skrilla.controller('createPlayerCtrl', function ($scope, searchService, currencyService, promotionService, modalService, cacheService, srefService, dataService) {
    $scope.sport = cacheService.getObjectOrElse("contestSport", function(){modalService.dismissAll()})
    $scope.validate = {};
    $scope.player = {sport: $scope.sport};

    $scope.create = function(){
        if(dataService.validatePlayer($scope.player, $scope.validate)) {
            modalService.confirm("Are you'd like to create this player", function () {
                $scope.player.name = $scope.player.lastName + ", " + $scope.player.firstName;
                searchService.post("players/" + $scope.sport, $scope.player, "Player successfully created").then(function (response) {
                    srefService.go("playerDetails", {id: response.data});
                    modalService.dismissAll();
                });
            });
        }
    }

});